import iso6391 from 'iso-639-1';
import type {ILanguageConfiguration} from '../models/interfaces/languageConfiguration.interface';
import type {NewProjectConfiguration} from '../models/interfaces/newProjectConfigurations';

/** Keys are language NAMES, not ISO codes. `sourceLanguageName: null` = source unsupported, user must pick one. */
export interface SanitizedPreset {
  sourceLanguageName: string | null;
  sourceConfig: ILanguageConfiguration | null;
  targetsByName: Record<string, ILanguageConfiguration>;
  shotChangeSync: boolean;
  dubbingScript: boolean;
  keepSongs?: boolean;
  isTranscribeOnly: boolean;
}

export const sanitizePreset = (
  preset: NewProjectConfiguration | undefined,
  supportedCodeLanguages: string[],
): SanitizedPreset => {
  const subtitles = preset?.config?.subtitles ?? {};
  const targetsByName = Object.entries(subtitles).reduce<Record<string, ILanguageConfiguration>>(
    (targets, [code, config]) => {
      const name = iso6391.getName(code);
      if (name !== '' && supportedCodeLanguages.includes(code)) {
        targets[name] = config;
      }
      return targets;
    },
    {},
  );

  const sourceCode = preset?.sourceLanguage;
  const sourceName = sourceCode === undefined ? '' : iso6391.getName(sourceCode);
  const hasSupportedSource = sourceCode !== undefined
    && sourceName !== ''
    && supportedCodeLanguages.includes(sourceCode);

  return {
    sourceLanguageName: hasSupportedSource ? sourceName : null,
    sourceConfig: hasSupportedSource
      ? preset?.config?.sourceTranscriptionConfig ?? null
      : null,
    targetsByName,
    shotChangeSync: !!preset?.config?.shotChangeSync,
    dubbingScript: !!preset?.config?.dubbingScript,
    keepSongs: preset?.config?.sourceTranscriptionConfig?.keepSongs,
    isTranscribeOnly: Object.keys(subtitles).length === 0,
  };
};
